'use client'

import { useCallback, useEffect, useState } from 'react'

import { OS_MACOS } from '@/shared/components/QuickStartArticleSelectors/quick-start-article-selectors.const'

const LANGUAGE_STORAGE_KEY = 'qs:language'
const OS_STORAGE_KEY = 'qs:os'
const DEFAULT_OS = OS_MACOS

export function useQuickStartLanguage(availableLanguages: string[]) {
  const [selectedLanguage, setSelectedLanguageState] = useState<string | null>(null)
  const [selectedOs, setSelectedOsState] = useState<string>(DEFAULT_OS)

  useEffect(() => {
    if (availableLanguages.length === 0) return

    try {
      const stored = localStorage.getItem(LANGUAGE_STORAGE_KEY)
      const initial = stored && availableLanguages.includes(stored) ? stored : availableLanguages[0]!
      setSelectedLanguageState(initial)
    } catch {
      setSelectedLanguageState(availableLanguages[0]!)
    }
  }, [availableLanguages])

  useEffect(() => {
    try {
      const stored = localStorage.getItem(OS_STORAGE_KEY)
      if (stored) setSelectedOsState(stored)
    } catch {
      // localStorage unavailable (private browsing, quota exceeded, disabled)
    }
  }, [])

  const setSelectedLanguage = useCallback((lang: string) => {
    setSelectedLanguageState(lang)
    try {
      localStorage.setItem(LANGUAGE_STORAGE_KEY, lang)
    } catch {
      // localStorage unavailable (private browsing, quota exceeded, disabled)
    }
  }, [])

  const setSelectedOs = useCallback((os: string) => {
    setSelectedOsState(os)
    try {
      localStorage.setItem(OS_STORAGE_KEY, os)
    } catch {
      // localStorage unavailable (private browsing, quota exceeded, disabled)
    }
  }, [])

  return { selectedLanguage, setSelectedLanguage, selectedOs, setSelectedOs }
}
